<template>
  <v-card height="510" class="">
    <v-card-title class="grey--text text-subtitle-1">
      Scansioni QR Code
    </v-card-title>
    <v-card-subtitle class="mt-2">
      <v-row no-gutters>
        <v-col cols="3" class="">
          <v-select
            :items="periodo_list"
            v-model="periodo"
            label="Periodo"
            item-value="value"
            item-text="label"
            hide-details
            dense
            outlined
          />
        </v-col>
        <v-col cols="3" class="pl-2" v-if="periodo == 0">
          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :return-value.sync="date"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="date_format"
                label="Intervallo"
                outlined
                hide-details
                dense
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="date"
              no-title
              scrollable
              range
              :allowed-dates="allowedDates"
            >
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="menu = false"> Cancel </v-btn>
              <v-btn text color="primary" @click="$refs.menu.save(date)">
                OK
              </v-btn>
            </v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="3" class="pl-2">
          <v-dialog v-model="dialog_elimina" width="600">
            <template v-slot:activator="{ on, attrs }">
              <v-btn outlined color="red" v-on="on" v-bind="attrs"
                >Elimina</v-btn
              >
            </template>
            <v-card>
              <v-card-title>Elimina Scansioni</v-card-title>
              <v-card-text>
                <v-row>
                  <v-col>
                    <v-select
                      :items="periodo_list"
                      v-model="delete_treshold"
                      label="Più vecchio di"
                      item-value="value"
                      item-text="label"
                      hide-details
                      dense
                      outlined
                    >
                    </v-select>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-btn @click="delete_scan" outlined color="red"
                      >Elimina</v-btn
                    >
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-dialog>
        </v-col>
      </v-row>
    </v-card-subtitle>
    <v-card-text class="scroll" v-if="!loading">
      <v-row>
        <v-col>
          Totale Scansioni:
          <span style="font-size: 20px">{{ scan_number }}</span>
        </v-col>
      </v-row>
      <v-list>
        <v-list-item v-for="prod in product_list" :key="prod.product_cod">
          <v-list-item-avatar>
            <v-img :src="avatar_img(prodotto(prod.product_cod))"></v-img>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>
              {{ prodotto(prod.product_cod).nome }}
            </v-list-item-title>
          </v-list-item-content>
          <v-list-item-action-text>
            <span style="font-size: 20px">{{ prod.qta }}</span>
          </v-list-item-action-text>
        </v-list-item>
      </v-list>
    </v-card-text>
  </v-card>
</template>
<script>
import moment from "moment";
export default {
  components: {},
  data() {
    return {
      loading: false,
      date: [
        moment().subtract(this.periodo, "days").format("YYYY-MM-DD"),
        moment().format("YYYY-MM-DD"),
      ],
      menu: false,
      modal: false,
      menu2: false,
      cliente_search: "",
      dialog_elimina: false,
      periodo_list: [
        { label: "Ultimo Giorno", value: 1 },
        { label: "Ultima Settimana", value: 7 },
        {
          label: "Ultimo Mese",
          value: moment().diff(moment().startOf("month"), "days"),
        },
        { label: "Ultimo Anno", value: moment().dayOfYear() },
        { label: "Da... a...", value: 0 },
      ],
      periodo: 7,
      delete_treshold: 7,
      lista_clienti: [],
      show_confronta: false,
      sort_by: "Totale",
      sort_tot: false,
      sort_blu: false,
      sort_verde: false,
      sort_cliente: true,
    };
  },
  mounted() {
    this.loading = true;
    this.$store
      .dispatch("fetch_qr_scan", {
        ts_inizio: moment().subtract(this.periodo, "days").format("X"),
      })
      .then(() => {
        this.loading = false;
      });
  },
  watch: {
    periodo() {
      this.loading = true;
      this.$store
        .dispatch("fetch_qr_scan", {
          ts_inizio: moment().subtract(this.periodo, "days").format("X"),
        })
        .then(() => {
          this.loading = false;
        });
    },
  },
  computed: {
    qr_scan() {
      return this.$store.getters.get_qr_scan;
    },
    scan_number() {
      return this.qr_scan.length;
    },
    product_list() {
      const productCount = {};
      this.qr_scan.forEach((scan) => {
        if (productCount[scan.productCode]) {
          productCount[scan.productCode]++;
        } else {
          productCount[scan.productCode] = 1;
        }
      });
      return Object.keys(productCount).map((productCode) => ({
        product_cod: productCode,
        qta: productCount[productCode],
      }));
    },
  },
  methods: {
    prodotto(cod_prodotto) {
      return this.$store.getters.get_prodotto_by_cod(cod_prodotto);
    },
    avatar_img(prod) {
      return (
        process.env.VUE_APP_API_ROOT +
        "/avatar_img/" +
        prod.id +
        "?t=" +
        prod.avatar_md5
      );
    },
    delete_scan() {
      this.$store
        .dispatch("delete_qr_scan", {
          ts_inizio: moment()
            .subtract(this.delete_treshold, "days")
            .format("X"),
        })
        .then(() => {
          this.dialog_elimina = false;
          this.loading = true;
          this.$store
            .dispatch("fetch_qr_scan", {
              ts_inizio: moment().subtract(this.periodo, "days").format("X"),
            })
            .then(() => {
              this.loading = false;
            });
        });
    },
  },
};
</script>